import { useState } from 'react';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import PlaylistPlayOutlinedIcon from '@mui/icons-material/PlaylistPlayOutlined';
import { Collapse, List } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { MyNavLink } from './';

export const Menu = () => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  return (

    <List component="nav">
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemIcon>
        <ListItemText primary="Manage Inventory" />
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <MyNavLink to="/materials" name="Materials" Icon={<ManageAccountsOutlinedIcon />} isChild />
          <MyNavLink to="/activities" name="Activities" Icon={<ManageAccountsOutlinedIcon />} isChild />
        </List>
      </Collapse>
      <MyNavLink to="/inventoryTracking" name="Inventory Tracking" Icon={<InventoryOutlinedIcon />} />
      <MyNavLink to="/auditHistory" name="Audit History" Icon={<ManageSearchOutlinedIcon />} />
      <MyNavLink to="/openBatches" name="Open Batches" Icon={<PlaylistAddOutlinedIcon />} />
      <MyNavLink to="/Distributor Batches" name="Distributor Batches" Icon={<PlaylistPlayOutlinedIcon />} />
    </List >)
};
